<template>
  <div class="page news">
    <IntroTextImage :block="news.notiziaInEvidenza[0]" type="custom" />
    <DoubleColBlock
      :news-highlight="news.notizieInEvidenza"
      :videos="news.video"
    />
    <CampaignsList :items="news.campagne" :title="$t('common.campagne')" />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'

const { configuration } = useStore()

// Fetch Data
const query = queries.news.getNewsPage

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.newsPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const news = computed(() => data.value.newsPageEntries?.[0])
const seo = computed(() => data.value?.newsPageEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
